import React from "react";
import LoaderIndicator from "../../Utility/loading";
import "./SendingAdminModal.css";

interface SendingAdminModalProps {
  isOpen: boolean;
  fontFamily?: string;
}

const SendingAdminModal: React.FC<SendingAdminModalProps> = ({
  isOpen,
  fontFamily = "Poppins, sans-serif",
}) => {
  if (!isOpen) return null;

  return (
    <div className="sending-admin-overlay">
      <div className="sending-admin-modal">
        <LoaderIndicator />
        <span className="sending-admin-text" style={{ fontFamily }}>
          Sending file to admin...
          <br />
          <small className="sending-admin-subtext">Please wait, new tab will open shortly</small>
        </span>
      </div>
    </div>
  );
};

export default SendingAdminModal;
